import React, { useState, useEffect } from 'react';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import {object, func, bool, string} from 'prop-types';
import {CloneObject} from '../../../utils/helpers';
import {CheckboxButton, CheckboxButtonGroup, DatePickerCustom, FormError, FormLabel, InputEntidad, InputLista, InputNumber, Modal, Accordion} from '../../common';
import {useFormErrors} from '../../hooks/useFormErrors';
import {VALIDATION_MESSAGE} from '../../../consts/validationMessage';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import {getDateNow} from '../../../utils/convert';
import {isNull} from '../../../utils/validator';
import {TIPS} from "../../../consts/tips";
const ElementoModal = (props) => {

    const entityInit = {
        id: 0,
        idCuenta: 0,
        idClaseElemento: 0,
        idTipoElemento: 0,
        cantidad: 0,
        fechaAlta: null,
        fechaBaja: null,
        activo: true,
        elementoEntidades: []
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
        listEntities: [],
    });

    const [tipoElementoState, setTipoElementoState] = useState({
        nombre: '',
        valor: 0,
        idUnidadMedida: 0
    });

    const mount = () => {
        setState(prevState => {
            return {
                ...prevState,
                entity: props.data.entity
            };
        });

        formSet({
            idTipoElemento: props.data.entity.idTipoElemento,
            cantidad: props.data.entity.cantidad,
            fechaAlta: props.data.entity.fechaAlta == null ? getDateNow() : props.data.entity.fechaAlta,
            fechaBaja: props.data.entity.fechaBaja,
            activo: props.data.entity.activo
        });
    }
    useEffect(mount, [props.data.entity]);

    const [formValues, formHandle, , formSet] = useForm({
        idTipoElemento: 0,
        cantidad: 0,
        fechaAlta: null,
        fechaBaja: null,
        activo: true
    });

    const [clase, setClase] = useState({ejecucionPeriodica: true});

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        if (!validate()) return;
        let row = CloneObject(state.entity);
        row.idTipoElemento = parseInt(formValues.idTipoElemento);
        row.cantidad = parseInt(formValues.cantidad);
        row.fechaAlta = formValues.fechaAlta;
        row.fechaBaja = formValues.fechaBaja;
        row.entidad = formValues.entidad;
        row.activo = formValues.activo;

        props.onConfirm(row);
    };

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.idTipoElemento <= 0) errors.idTipoElemento = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.cantidad <= 0) errors.cantidad = 'Ingresá un número mayor a cero';
        if (formValues.fechaAlta == null) errors.fechaAlta = VALIDATION_MESSAGE.REQUIRED_DATE;

        return errors;
    }

    function getCurrent(list) {
        const today = getDateNow();
        const current = list.find(f => (isNull(f.fechaDesde) || new Date(f.fechaDesde) <= today) &&
            (isNull(f.fechaHasta) || new Date(f.fechaHasta) >= today));
        return current;
    }

    return (
        <Modal
            size="lg"
            title={`Elemento: ${(state.entity.id > 0) ? tipoElementoState.nombre : "Nuevo"}`}
            onEscape={() => props.onDismiss()}
            body={(<>
                            <div className="row">
                                <div className="mb-3 col-12">
                                    <Accordion title="Detalle del elemento" startOpen={true}>
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-12 col-md-12">
                                                <label htmlFor="idClaseElemento"
                                                       className="form-label">Clase</label>
                                                <InputEntidad
                                                    name="idClaseElemento"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={props.data.entity.idClaseElemento}
                                                    onUpdate={({target}) => setClase(target.row ?? {ejecucionPeriodica: true})}
                                                    disabled={true}
                                                    title="ClaseElemento"
                                                    entidad="ClaseElemento"
                                                />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6">
                                                <FormLabel htmlFor="idTipoElemento" required>Tipo</FormLabel>
                                                <InputEntidad
                                                    name="idTipoElemento"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idTipoElemento') ? 'is-invalid' : ''}`}
                                                    value={formValues.idTipoElemento}
                                                    onChange={formHandle}
                                                    onUpdate={(event) => {
                                                        if (event.target.row) {
                                                            const tipoElemento = event.target.row;
                                                            const valorVigente = getCurrent(tipoElemento.tipoElementoValores);
                                                            setTipoElementoState({
                                                                nombre: tipoElemento.nombre,
                                                                valor: valorVigente ? valorVigente.valor : 0,
                                                                idUnidadMedida: tipoElemento.idUnidadMedida,
                                                            })
                                                        } else {
                                                            setTipoElementoState({
                                                                nombre: '',
                                                                valor: 0,
                                                                idUnidadMedida: 0,
                                                            })
                                                        }
                                                    }}
                                                    disabled={props.disabled}
                                                    filter={(row) => row.idClaseElemento === props.data.entity.idClaseElemento}
                                                    title="TipoElemento"
                                                    entidad="TipoElemento"
                                                />
                                                <FormError message={errorOf('idTipoElemento')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-2">
                                                <label htmlFor="valor" className="form-label">Valor vigente</label>
                                                <input
                                                    name="valor"
                                                    type="number"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={tipoElementoState.valor}
                                                    disabled={true}
                                                />
                                                <FormError />
                                            </div>
                                            <div className="mb-3 col-12 col-md-3">
                                                <label htmlFor="idUnidadMedida" className="form-label">Unidad
                                                    medida</label>
                                                <InputLista
                                                    name="idUnidadMedida"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={tipoElementoState.idUnidadMedida}
                                                    disabled={true}
                                                    title="UnidadMedida"
                                                    lista="UnidadMedida"
                                                />
                                                <FormError />
                                            </div>
                                            <div className="mb-3 col-12 col-md-3">
                                                <FormLabel htmlFor="cantidad" required>Cantidad</FormLabel>
                                                <InputNumber
                                                    name="cantidad"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('cantidad') ? 'is-invalid' : ''}`}
                                                    value={formValues.cantidad}
                                                    onChange={formHandle}
                                                    precision={0}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('cantidad')} />
                                            </div>
                                            <div className="mb-3 col-6 col-md-3">
                                                <FormLabel htmlFor="fechaAlta" required>Fecha alta</FormLabel>
                                                <DatePickerCustom
                                                    name="fechaAlta"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('fechaAlta') ? 'is-invalid' : ''}`}
                                                    value={formValues.fechaAlta}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('fechaAlta')} />
                                            </div>
                                            <div className="mb-3 col-6 col-md-3">
                                                <label htmlFor="fechaBaja" className="form-label">Fecha baja</label>
                                                <DatePickerCustom
                                                    name="fechaBaja"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.fechaBaja}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError />
                                            </div>
                                            {!clase.ejecucionPeriodica &&
                                                <div className="mb-3 col-6 col-md-4">
                                                    <CheckboxButtonGroup label="Facturación">
                                                        <CheckboxButton
                                                            name="activo"
                                                            label="Pendiente de facturación"
                                                            checked={formValues.activo}
                                                            onChange={formHandle}
                                                            disabled={props.disabled}
                                                        />
                                                    </CheckboxButtonGroup>
                                                </div>
                                            }
                                        </div>
                                    </Accordion>
                                </div>
                            </div>

                            <div className="row">
                                <div className="mb-3 col-12">
                                    <Accordion title="Información adicional">
                                        <DataTaggerFormRedux
                                            title="Información adicional de rubros comercio"
                                            tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_RUBRO_COMERCIO_MODAL}
                                            processKey={props.processKey}
                                            entidad="RubroComercio"
                                            idEntidad={state.entity.id}
                                            disabled={props.disabled}
                                        />
                                    </Accordion>
                                </div>
                            </div>
            </>)}
            footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
            </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
            )}
            footerClassName={props.disabled ? 'f-align' : ''}
        />
    );
}

ElementoModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

ElementoModal.defaultProps = {
    disabled: false
};

export default ElementoModal;
